import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Get the auth token from the service.
    const authToken = this.auth.getAuthorizationToken();
    if (authToken === null) {
      //we do nothing
      return next.handle(req);
    }

    const authReq = req.clone({ setHeaders: { Authorization: 'Bearer ' + authToken } });

    // send cloned request with header to the next handler.
    return next.handle(authReq).catch((err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          if (err.error && err.error.returnCode && err.error.returnCode.label) {
            if (err.error.returnCode.label === 'E_PASSWORD_EXPIRED') {
              // redirect to Change Password
              this.router.navigate(['/change-password']);
              return Observable.empty();
            }
          }

          if (
            !authReq.url.match(/v1\/user\/data/) &&
            !(authReq.url.match(/v1\/user/) && authReq.method === 'DELETE')
          ) {
            // token is not working anymore
            this.auth.logout();
            window.location.reload();
          }
        }
      }
      // other case throw an error
      return Observable.throw(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/http-interceptors/auth-interceptor.ts